export default class IntegrationEvent {
  constructor(idInDB, contractId, eventDate, eventType, isApplied, rateIsChanged, commands, isIntegrationEvent, comments) {
    this.idInDB = idInDB;
    this.contractId = contractId;
    this.eventDate = eventDate;
    this.eventType = eventType;
    this.isApplied = isApplied;
    this.rateIsChanged = rateIsChanged;
    this.commands = commands;
    this.isIntegrationEvent = isIntegrationEvent;
    this.comments = comments;
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create IntegrationEvent from data if data is null.");

    return new IntegrationEvent(
      data.idInDB,
      data.contractId,
      data.eventDate,
      data.eventType,
      data.isApplied,
      data.rateIsChanged,
      data.commands,
      data.isIntegrationEvent,
      data.comments
    )
  }
}
